export const landingPagePath = '/';
export const golfHotelPath = '/golf';
export const golfBrauPath = '/golfbrau';
export const artistoPath = '/lartistosousse';
export const leQGPath = '/leqg';
export const treesomePath = '/treesomesousse';
export const cateringPath = '/catering';
export const tiniriCampPath = '/tiniricamp';
export const fairgroundPath = '/fairground';



// WEBPACK FOOTER //
// ./src/assets/paths.js